//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
import React, { useEffect, useContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Col, Container, Row, ListGroup, Tab } from "react-bootstrap";
import CandidateSearch from "./candidate/candidateSearch";
import ViewGA from "./genericAccounts/viewGenericAccounts/viewGA";
import { Context } from "./common/context/Context";
import { CandidatePageActions } from "./candidatePageActions";
import { getCandidatesSearchCMSContent } from "./common/helpers/candidateCmsHelper";
import SystemMessage from "./systemMessages/message";
import SearchSystemMessage from "./systemMessages/searchSystemMessage";
import "react-datetime/css/react-datetime.css";
import ErrorAlertMessage from "./common/alertMessages/errorAlertMessage";

const Candidates = () => {
  const context = useContext(Context);
  const [errorAlert, setErrorAlert] = useState({
    showAlert: false,
  });
  const [adminCandidateCMS, setAdminCandidateSearchCMS] = useState({
    title: "",
    description: "",
    tabNavigationTitle: "",
    pageContent: {},
  });

  const getProgramStatus = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetProgramStatus().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setProgramStatusList(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getAllGenericAccount = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetAllGenericAccount().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          let resData = res.data && res.data;
          let tableData = resData.map((x) => ({
            ...x,
            endDate: x && x.endDate.slice(0, 10),
          }));
          context.setViewGATableData(tableData);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getRTPersona = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetRTPersona().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setRTPersona(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getCascadeClientData = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetCascadeClientData().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setCascadeClientData(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getRTProgramClass = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetRTProgramClass().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setRTProgramClass(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getRTProgramTemplate = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetRTProgramTemplate().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setRTProgramTemplate(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getServiceOffice = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    let countryCode = "US";

    CandidatePageActions.GetServiceOffice(countryCode).then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setServiceOffice(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getCountriesList = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    let locale = "en-US";
    let key = "country";

    CandidatePageActions.GetCountriesList(locale, key).then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          let countryLists = [];
          res?.data[0]?.items?.forEach((item) => {
            let country = {};
            country.title = item.title;
            item?.standardCodes?.forEach((subItem) => {
              if (subItem?.itemCodeStandardName === "rt") {
                country.standardCodeValue = subItem?.standardCodeValue;
                countryLists.push(country);
              }
            });
          });
          context.setCountryList(countryLists);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };
  const getRightOfficeId = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetRightOfficeId().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          context.setRightOfficeId(res.data);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const getAllUsersEmail = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));

    CandidatePageActions.GetAllUsersEmail().then(
      (res) => {
        if (res.status === 200 || res.status === 204) {
          let resData = res.data && res.data;
          resData = resData && resData.map((x) => x.emailAddress);
          context.setUsersEmailList(resData);
        } else {
          refErrorMessageAlert.showAlert = true;
          setErrorAlert(refErrorMessageAlert);
          window.scrollTo(0, 0);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  const showErrorModal = () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
    refErrorMessageAlert.showAlert = false;
    setErrorAlert(refErrorMessageAlert);
  };

  const getAdminCandidateSearchCMSContent = async () => {
    let refErrorMessageAlert = JSON.parse(JSON.stringify(errorAlert));
    const cmsContent = await getCandidatesSearchCMSContent();

    if (cmsContent) {
      setAdminCandidateSearchCMS(cmsContent);
    } else {
      refErrorMessageAlert.showAlert = true;
      setErrorAlert(refErrorMessageAlert);
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getAdminCandidateSearchCMSContent();
    getProgramStatus();
    getCascadeClientData();
    getRTPersona();
    getRTProgramClass();
    getRTProgramTemplate();
    getCountriesList();
    if (
      context?.permissionsList?.includes(
        "Generic Account.viewgenericaccount"
      ) ||
      context?.permissionsList?.includes("Generic Account.editgenericaccount")
    ) {
      getAllGenericAccount();
      getAllUsersEmail();
    }
  }, []);

  return (
    <React.Fragment>
      <Helmet title="Tabs" />
      <Container fluid className="p-0">
        <h1 className="h3 mb-3">{adminCandidateCMS?.title}</h1>

        <Row>
          <Col lg="12">
            <Tab.Container id="candidate-tabs" defaultActiveKey="#candidate">
              <ListGroup horizontal>
                <ListGroup.Item action href="#candidate">
                  {adminCandidateCMS?.title}
                </ListGroup.Item>
                <ListGroup.Item action href="#genericAccount">
                  {
                    adminCandidateCMS?.pageContent[
                      "viewGenericAccounts.GenericAccount"
                    ]?.Title
                  }
                </ListGroup.Item>
              </ListGroup>
              {errorAlert?.showAlert && (
                <ErrorAlertMessage
                  alertMessage="AllPages.ErrorAlertMessage"
                  showAlert={showErrorModal}
                />
              )}
              <Tab.Content>
                <Tab.Pane eventKey="#candidate">
                  {context?.permissionsList?.includes(
                    "Candidate.searchandviewcandidates"
                  ) && <CandidateSearch candidateCMSData={adminCandidateCMS} />}
                  {context?.permissionsList?.includes(
                    "System Messages.viewsystemmessages"
                  ) && (
                      <SearchSystemMessage candidateCMSData={adminCandidateCMS} />
                    )}
                  {context?.permissionsList?.includes(
                    "System Messages.publishsystemmessages"
                  ) && <SystemMessage candidateCMSData={adminCandidateCMS} />}
                </Tab.Pane>
                <Tab.Pane eventKey="#genericAccount">
                  <ViewGA candidateCMSData={adminCandidateCMS} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Candidates;
